/**
 * Resolve a time entry's billable client per the spec:
 *   regardingobjectid →
 *     1. Account → that account
 *     2. Work Order → msdyn_serviceaccount
 *     3. Project → msdyn_customer (project's account)
 */
export function resolveClient(entry, ctx) {
    const r = entry.regardingobjectid;
    if (!r)
        return;
    if (r.type === "account") {
        return ctx.accounts.find((a) => a.accountid === r.id);
    }
    if (r.type === "msdyn_workorder") {
        const wo = ctx.workOrders.find((w) => w.msdyn_workorderid === r.id);
        return wo ? ctx.accounts.find((a) => a.accountid === wo.msdyn_serviceaccount) : undefined;
    }
    if (r.type === "msdyn_project") {
        const p = ctx.projects.find((x) => x.msdyn_projectid === r.id);
        return p?.msdyn_customer ? ctx.accounts.find((a) => a.accountid === p.msdyn_customer) : undefined;
    }
}
export function clientIdFor(entry, ctx) {
    const r = entry.regardingobjectid;
    if (!r)
        return;
    if (r.type === "account")
        return r.id;
    if (r.type === "msdyn_workorder")
        return ctx.workOrders.find((w) => w.msdyn_workorderid === r.id)?.msdyn_serviceaccount;
    if (r.type === "msdyn_project")
        return ctx.projects.find((p) => p.msdyn_projectid === r.id)?.msdyn_customer;
}
